// 关于与帮助：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 关于和帮助
export const ui = Object.freeze({
  "pcAbout.about": "關於先搜",
  "pcAbout.contact": "聯絡我們",
  "pcAbout.join": "加入我們",
  "pcAbout.privacy": "隱私説明",
  "pcAbout.help": "幫助中心",
  "pcAbout.companyAlt": "先搜科技",
  "pcAbout.value1": "理念",
  "pcAbout.value1Desc": "以客戶為中心，卓越服務",
  "pcAbout.value2": "精神",
  "pcAbout.value2Desc": "以奮鬥為根本，持續創造",
  "pcAbout.value3": "責任",
  "pcAbout.value3Desc": "以行業為己任，協作共贏",
  "pcAbout.value4": "目標",
  "pcAbout.value4Desc": "以誠信為基石，價值共享",
  "pcAbout.onlineMessage": "在線留言",
  "pcAbout.name": "姓名",
  "pcAbout.phone": "電話",
  "pcAbout.email": "電郵地址",
  "pcAbout.message": "留言內容",
  "pcAbout.enterName": "請輸入您的姓名",
  "pcAbout.enterPhone": "請輸入您的聯繫電話",
  "pcAbout.enterEmail": "請輸入您的電郵地址",
  "pcAbout.enterMessage": "請輸入您的留言內容",
  "pcAbout.nameMax": "姓名不能超過50個字符",
  "pcAbout.phoneMax": "聯繫電話不能超過30個字符",
  "pcAbout.invalidEmail": "請輸入正確的電郵地址格式",
  "pcAbout.emailMax": "電郵地址不能超過100個字符",
  "pcAbout.messageMax": "留言內容不能超過1000個字符",
  "pcAbout.submit": "提交留言",
  "pcAbout.responsibilities": "崗位職責",
  "pcAbout.requirements": "任職要求",
  "pcAbout.apply": "立即申請",
  "pcAbout.helpSearch": "搜索幫助文檔，輸入關鍵詞...",
  "pcAbout.hotSearch": "熱門搜索：",
  "pcAbout.moreQuestions": "還有其他問題？",
  "pcAbout.contactHelp": "聯絡我們的客服團隊，我們將為您提供專業的幫助",
  "pcAbout.contactSupport": "聯繫客服",
  "pcAbout.close": "關閉",
  "pcAbout.pageTitle": "關於我們 - 先搜科技",
  "pcAbout.fallbackTitle": "關於我們",
  "pcAbout.address": "公司地址",
  "pcAbout.contactPhone": "聯繫電話",
  "pcAbout.contactEmail": "電子電郵地址",
  "pcAbout.hours": "工作時間",
  "pcAbout.weekdays": "週一至週五 9:00-18:00",
  "pcAbout.addressValue": "深圳市南山區僑香路4060號704B",
  "pcAbout.submitted": "留言提交成功，我們會盡快聯繫您",
  "pcAbout.submitFailed": "留言提交失敗，請稍後重試",
  "pcAbout.content.about_xsou":
    '<p>深圳先搜科技有限公司成立於 2017 年 8 月 24 日，專注半導體儲存晶片領域，是國內領先的儲存晶片供應鏈綜合服務平台，致力打造中國半導體晶片供應鏈第一品牌，以 "改善半導體晶片全產業鏈營商環境" 為使命，為行業提供金流、物流、資料流 "三流合一" 的一站式解決方案。</p><p>公司深耕儲存行業上下游資源整合，憑藉專業供應鏈能力與金融服務，為客戶提供高效、安全、低成本的產業服務，已與三星、美光、海力士、英特爾、長江存儲等全球一線原廠及國內知名品牌廠商建立長期穩定合作，成為儲存行業值得信賴的供應鏈合作伙伴。</p>',
  "pcAbout.content.contact":
    "<p>公司地址：深圳市南山區僑香路4060號704B</p><p>聯繫電話：400-966-2855</p><p>電子電郵地址：fengke@xsou.com</p><p>工作時間：週一至週五 9:00-18:00</p>",
  "pcAbout.content.join":
    "<p>先搜科技正在快速發展，我們期待有才華、有激情的你加入我們的團隊！在這裏，你將獲得廣闊的發展空間和良好的職業發展機會。</p>",
  "pcAbout.content.privacy":
    "<h3>1. 隱私政策概述</h3><p>深圳先搜科技有限公司（以下簡稱“先搜科技”或“我們”）非常重視用戶隱私和數據保護。本隱私政策旨在説明我們如何收集、使用、儲存和保護您的個人資料。</p><h3>2. 資料收集</h3><p>我們可能會收集您在使用我們服務過程中提供的個人資料，包括但不限於：姓名、聯絡方式、公司資料、瀏覽記錄、交易資料等。</p><h3>3. 資料使用</h3><p>我們收集的資料將用於：提供和改進服務、處理交易、客戶服務、安全保障、市場調研等。我們不會向第三方出售您的個人資料。</p><h3>4. 資料保護</h3><p>我們採用業界領先的安全技術和措施來保護您的資料安全，包括數據加密、訪問控制、安全審計等。</p><h3>5. 用戶權利</h3><p>您有權訪問、更正、刪除您的個人資料，也可以隨時撤回您的授權。如需幫助，請聯絡我們的客服團隊。</p><h3>6. 政策更新</h3><p>我們可能會不定期更新本隱私政策，更新後的政策將在網站上發佈。您的持續使用視為同意更新後的政策。</p>",
  "pcAbout.content.help":
    "<p>如在註冊登入、訂單查詢、物流跟蹤、售後服務、發票申請等環節遇到問題，可通過客服渠道聯絡我們。</p>",
});

export const messages = Object.freeze({ ...ui });

// 香港帮助与招聘展示内容
export const aboutContent = Object.freeze({
  jobList: [
    {
      id: 1,
      title: "前端開發工程師",
      type: "全職",
      location: "深圳",
      duties: [
        "負責公司Web前端產品的開發和維護",
        "參與前端技術架構設計和優化",
        "與產品、設計、後端團隊緊密協作",
        "持續改進用戶體驗和頁面性能",
      ],
      requirements: [
        "本科及以上學歷，計算機相關專業",
        "3年以上前端開發經驗",
        "精通Vue.js、React等主流框架",
        "熟悉HTML5、CSS3、JavaScript等技術",
        "有良好的溝通能力和團隊協作精神",
      ],
    },
    {
      id: 2,
      title: "後端開發工程師",
      type: "全職",
      location: "深圳",
      duties: [
        "負責公司後端系統的設計和開發",
        "優化系統性能，保障系統穩定運行",
        "參與技術方案評審和技術選型",
        "編寫技術文檔和代碼規範",
      ],
      requirements: [
        "本科及以上學歷，計算機相關專業",
        "3年以上Java/Python開發經驗",
        "熟悉Spring Boot/Django等框架",
        "熟悉MySQL、Redis等數據庫",
        "有分佈式系統開發經驗者優先",
      ],
    },
    {
      id: 3,
      title: "產品經理",
      type: "全職",
      location: "深圳",
      duties: [
        "負責產品規劃和需求分析",
        "制定產品路線圖和迭代計劃",
        "協調研發、設計、運營等團隊",
        "跟蹤產品數據和用戶反饋",
      ],
      requirements: [
        "本科及以上學歷，2年以上產品經理經驗",
        "有B2B平台產品經驗者優先",
        "具備良好的溝通協調能力",
        "熟練使用Axure、XMind等工具",
      ],
    },
    {
      id: 4,
      title: "銷售專員",
      type: "全職",
      location: "深圳",
      duties: [
        "開發新客戶，維護老客戶關係",
        "完成銷售目標和業績指標",
        "收集市場資料和競品分析",
        "參與展會和市場活動",
      ],
      requirements: [
        "大專及以上學歷，1年以上銷售經驗",
        "電子元器件行業經驗者優先",
        "具備良好的溝通能力和抗壓能力",
        "能適應出差",
      ],
    },
  ],
  hotTags: ["註冊登入", "訂單查詢", "物流跟蹤", "售後服務", "發票申請"],
  helpCategories: [
    {
      id: "all",
      name: "全部問題",
      icon: "全部",
    },
    {
      id: "register",
      name: "註冊登入",
      icon: "賬號",
    },
    {
      id: "order",
      name: "訂單相關",
      icon: "訂單",
    },
    {
      id: "payment",
      name: "支付問題",
      icon: "支付",
    },
    {
      id: "delivery",
      name: "物流配送",
      icon: "物流",
    },
    {
      id: "aftersale",
      name: "售後服務",
      icon: "售後",
    },
  ],
  helpArticles: [
    {
      id: 1,
      title: "如何註冊成為先搜科技會員？",
      summary: "註冊會員非常簡單，只需幾個步驟即可完成...",
      detail:
        "**註冊步驟：**\n\n1. 點擊頁面右上角的「註冊」按鈕\n2. 填寫流動電話號碼並獲取驗證碼\n3. 設置登入密碼（6-20位字母或數字）\n4. 閲讀並同意《用戶服務協議》\n5. 點擊「立即註冊」完成註冊\n\n**註冊後您將獲得：**\n- 免費瀏覽所有供應資料\n- 發佈採購需求\n- 在線諮詢供應商\n- 享受專屬會員價格",
    },
    {
      id: 2,
      title: "如何找回登入密碼？",
      summary: "如果您忘記了密碼，可以通過以下方式找回...",
      detail:
        "**找回密碼方式：**\n\n1. 在登入頁面點擊「忘記密碼」\n2. 輸入註冊時的流動電話號碼\n3. 獲取並輸入短訊驗證碼\n4. 設置新的登入密碼\n5. 點擊「確認修改」完成找回\n\n**温馨提示：**\n- 驗證碼有效期為5分鐘\n- 建議設置包含字母和數字的複雜密碼\n- 如流動電話號碼已變更，請聯繫客服處理",
    },
    {
      id: 3,
      title: "如何發佈供應資料？",
      summary: "發佈供應資料需要先登入賬號，然後按照提示填寫...",
      detail:
        "**發佈步驟：**\n\n1. 登入後進入「我的」頁面\n2. 點擊「發佈供應」按鈕\n3. 填寫產品資料（料號、品牌、數量等）\n4. 上傳產品圖片（最多5張）\n5. 設置價格和交易方式\n6. 點擊「發佈」完成操作\n\n**注意事項：**\n- 請確保產品資料真實準確\n- 圖片需清晰展示產品細節\n- 發佈的供應資料將在審核通過後展示",
    },
    {
      id: 4,
      title: "訂單如何取消？",
      summary: "訂單取消需要在訂單狀態為待付款時操作...",
      detail:
        "**取消訂單説明：**\n\n**待付款訂單：**\n1. 進入「我的訂單」頁面\n2. 找到需要取消的訂單\n3. 點擊「取消訂單」按鈕\n4. 選擇取消原因並確認\n\n**已付款訂單：**\n- 如需取消，請聯繫賣家協商\n- 賣家同意後可申請退款\n- 退款將在3-7個工作日內原路返回\n\n**温馨提示：**\n- 請在下單後儘快確認訂單資料\n- 已發貨訂單不支持直接取消",
    },
    {
      id: 5,
      title: "支持哪些支付方式？",
      summary: "我們支持多種支付方式，包括支付寶、微信支付...",
      detail:
        "**支持的支付方式：**\n\n1. **支付寶** - 支持個人和企業賬戶\n2. **微信支付** - 支持微信零錢和銀行卡\n3. **銀行卡支付** - 支持各大銀行儲蓄卡和信用卡\n4. **對公轉賬** - 適用於大額訂單（需聯繫客服）\n\n**支付安全：**\n- 所有支付通道均經過安全加密\n- 支持多種安全驗證方式\n- 7x24小時風控監測保障",
    },
    {
      id: 6,
      title: "如何查詢物流資料？",
      summary: "訂單發貨後，您可以在訂單詳情頁查看物流資料...",
      detail:
        "**查詢物流方式：**\n\n1. 進入「我的訂單」頁面\n2. 找到已發貨的訂單\n3. 點擊「查看物流」按鈕\n4. 實時查看物流跟蹤資料\n\n**物流資料包含：**\n- 快遞公司名稱\n- 快遞單號\n- 物流跟蹤記錄\n- 預計送達時間\n\n**温馨提示：**\n- 發貨後24小時內可查詢物流資料\n- 如物流長時間無更新，請聯繫賣家或客服",
    },
    {
      id: 7,
      title: "售後服務政策是什麼？",
      summary: "我們提供7天無理由退換貨服務...",
      detail:
        "**售後服務政策：**\n\n**7天無理由退換貨：**\n- 收到商品後7天內可申請\n- 商品需保持全新未使用狀態\n- 不影響二次銷售\n\n**質量問題處理：**\n- 收到商品後發現質量問題請及時拍照留存\n- 聯繫賣家或客服申請售後\n- 我們將根據實際情況提供退換貨服務\n\n**售後服務流程：**\n1. 進入訂單詳情頁\n2. 點擊「申請售後」\n3. 選擇售後類型並填寫原因\n4. 上傳相關憑證圖片\n5. 提交申請等待處理",
    },
    {
      id: 8,
      title: "如何申請發票？",
      summary: "在訂單完成後，您可以在個人中心申請發票...",
      detail:
        "**申請發票流程：**\n\n1. 訂單完成後進入「我的訂單」\n2. 找到需要開票的訂單\n3. 點擊「申請發票」按鈕\n4. 選擇發票類型（普通發票/增值税專用發票）\n5. 填寫發票資料\n6. 提交申請\n\n**發票説明：**\n- 普通發票將發送至您的郵箱\n- 增值税專用發票需提供完整資質資料\n- 發票將在申請後1-3個工作日內開具\n\n**注意事項：**\n- 請確保發票資料準確無誤\n- 已開具的發票如需修改請聯繫客服",
    },
  ],
});
